import { render, staticRenderFns } from "./tiscAccordion.vue?vue&type=template&id=1a23be5e&scoped=true&"
import script from "./tiscAccordion.vue?vue&type=script&lang=js&"
export * from "./tiscAccordion.vue?vue&type=script&lang=js&"
import style0 from "./tiscAccordion.vue?vue&type=style&index=0&id=1a23be5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a23be5e",
  null
  
)

export default component.exports